import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
  withHotelCenterSiteMap,
  siteMapPropType,
  processorSet,
} from '@bingads-webui-campaign-react/with-site-map';
import { TreeMenu } from '@bingads-webui-campaign-react/tree-menu';

const idsToHideSelf = ['hotel-center-setup'];
const idsToHideChildren = ['report', 'hotel-center-overview', 'reconciliationreport'];
const pruneSitemap = (sitemap, ids, hideSelfIdsArray) => {
  const pruneNode = (node, ids2) => {
    const { id, children } = node;

    const result = _.clone(node);

    if (_.some(ids2, x => x === id)) {
      result.children = [];
    }

    if (children && children.length > 0) {
      result.children = _.map(result.children, x => pruneNode(x, ids2));
    }

    return result;
  };

  const result = _.chain(sitemap)
    .filter(x => (_.indexOf(hideSelfIdsArray, x.id) === -1))
    .map(x => pruneNode(x, ids))
    .value();
  return result;
};

export const Loader = (props) => {
  const { siteMap, updateAvailability } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });

  useEffect(() => {
    const available = !_.isEmpty(selectedParent);
    updateAvailability(available);
    props.changeLayout({ menu: { hotelCenterMenu: available } });
  });

  const prunedSitemap = pruneSitemap(siteMap, idsToHideChildren, idsToHideSelf);
  return props.isVisible ? (<TreeMenu {...props} siteMap={prunedSitemap} />) : null;
};

Loader.propTypes = {
  changeLayout: PropTypes.func,
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool,
};

Loader.defaultProps = {
  changeLayout: _.noop,
  updateAvailability: _.noop,
  isVisible: false,
};

export const HotelCenterPageMenuLoader = withHotelCenterSiteMap(
  React.memo(Loader),
  processorSet.all
);
